import { render } from "./CustomerProductPropertiesItem.vue?vue&type=template&id=7811a341&scoped=true&ts=true"
import script from "./CustomerProductPropertiesItem.vue?vue&type=script&lang=ts"
export * from "./CustomerProductPropertiesItem.vue?vue&type=script&lang=ts"

import "./CustomerProductPropertiesItem.vue?vue&type=style&index=0&id=7811a341&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7811a341"]])

export default __exports__